<nav class="nav flex-column">
  <ng-content></ng-content>
</nav>
